module.exports = __webpack_public_path__ + "static/media/resume.927f5dd6.pdf";